// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    actualCompletionDate: 'Date réelle d\'achèvement : ',
    actualCompletionDateFull: 'Date réelle d\'achèvement',
    AutoAssign_Issue: 'Affecter automatiquement les nouveaux problèmes à :',
    AutoAssign_Note: 'Le membre choisi sera assigné à chaque fois qu\'une activité est ajoutée au projet',
    AutoAssign_Request: 'Affecter automatiquement les nouvelles demandes à :',
    AutoAssign_Task: 'Affecter automatiquement les nouvelles tâches à :',
    AutoAssign_Title: 'Affectation automatique',
    BaselineCapturedFeedback: 'La référence du projet est capturée. Allez dans une vue Gantt et choisissez l\'option « Afficher » pour la vérifier.',
    BaselineCaptureLabel: 'Capturer la référence',
    BaselineOverwrite: 'Écraser la référence actuelle ?',
    BaselineOverwriteDescription: 'Vous avez déjà une référence pour ce projet. Si vous continuez, la référence actuelle sera perdue.',
    BaselineOverwrittenFeedback: 'La référence du projet a été écrasée. Allez dans une vue Gantt et choisissez l\'option « Afficher » pour la vérifier.',
    BaselineRecaptureLabel: 'Écraser la référence',
    BaselineSuccess: 'La référence a été capturée avec succès.',
    Billed: 'Facturé',
    Billing: 'Facturation',
    BillingSettingsTitle: 'Paramètres de facturation',
    BillingTypeNotBillable: 'Non facturable',
    BillingTypeProjectBillingSettings: 'Paramètres de facturation du projet',
    btnNotifications: 'Notifications',
    BudgetLeft: 'restant',
    BudgetTotal: 'total',
    By: 'par ',
    Change: 'modifier',
    Close: 'Fermer',
    ConfirmStatusDialogTitle: 'Terminer « {0} » ?',
    CreateInvoice_Title: 'Créer une facture',
    DayPluralFormat: '1#{0} jour#{0} jours',
    Days: '({0}j)',
    DeleteActivity: 'Supprimer l\'activité',
    DeleteProject: 'Supprimer le projet',
    Dependencies_Count: '1#{0} dépendance#{0} dépendances',
    DifferPermissionsMessage: 'indique que les autorisations du membre actuel du projet diffèrent des autorisations de rôle par défaut',
    Disable_Dates_Rollup: 'Désactiver le report des dates',
    Disable_Dates_Rollup_Feedback: 'Le report des dates a été désactivé',
    DueIn_Ok: 'à échéance dans {0}',
    DueIn_Trouble: '{0} en retard',
    DueIn_Warning: 'à échéance aujourd\'hui',
    EditRoleAndPermissions: 'Modifier le rôle et les autorisations',
    Enable_And_Reschedule: 'Activer et replanifier',
    Enable_Dates_Rollup: 'Activer le report des dates',
    Enable_Dates_Rollup_Description: 'L\'activation du report des dates replanifiera ce projet.',
    Enable_Dates_Rollup_Feedback: 'Le report des dates a été activé',
    Enable_Dates_Rollup_Title: 'Les dates du projet seront mises à jour',
    endDate: 'Date de fin planifiée : ',
    endDateFull: 'Date de fin planifiée',
    endLessThenStartMsg: 'La \'date de fin\' ne peut pas être antérieure à la \'date de début\'',
    estimatedHours: '1# heure estimée# heures estimées',
    ExportToMsProject: 'Exporter vers MS Project',
    Fields: '1#{0} champ#{0} champs',
    FillCustomFields: '{0} doit encore être renseigné',
    Follow: 'Suivre',
    follow_all_activities_label: 'Suivre toutes les activités',
    hide_checklist_label: 'Masquer la checklist',
    HideCustomFields: 'Masquer les champs personnalisés',
    hoursLeft: '1# heure restante# heures restantes',
    HoursOf: 'h sur ',
    HtmlField_ReadAll: '... lire tout',
    ImDoneText: 'J\'ai terminé',
    invoice_creation_no_customer_disabled_reason: 'Sélectionnez un client pour pouvoir créer une facture',
    IsMilestone: 'Ceci est une étape clé',
    issue: 'Problème',
    MarkAsMilestone: 'Marquer comme une étape clé',
    MemberPermission_Add: 'Ajouter',
    MemberPermission_Add_For_Someone_Else: 'Ajouter pour quelqu\'un d\'autre',
    MemberPermission_Add_Own: 'Ajouter soi-même',
    MemberPermission_CanEditActualExpenses: 'Modifier toutes les dépenses réelles',
    MemberPermission_CanEditPlannedExpenses: 'Modifier toutes les dépenses prévues',
    MemberPermission_CanLogExpenses: 'Ajouter ses propres dépenses',
    MemberPermission_CanManageProjectMembers: 'Gérer les membres et les autorisations',
    MemberPermission_CanManageProjectMembersAndAllocations: 'Gérer les membres, les autorisations et les allocations',
    MemberPermission_CanViewAllExpenses: 'Voir toutes',
    MemberPermission_CanViewMembersAndAssignees: 'Voir',
    MemberPermission_Delete: 'Supprimer',
    MemberPermission_Delete_All: 'Tout supprimer',
    MemberPermission_Delete_Or_Archive: 'Supprimer/Archiver',
    MemberPermission_Edit: 'Modifier',
    MemberPermission_Edit_All: 'Tout modifier',
    MemberPermission_Edit_Assigned: 'Modifier les assignés',
    MemberPermission_Manage_Assigned: 'Gérer les assignés',
    MemberPermission_View_All: 'Tout voir',
    MemberPermission_View_and_Manage: 'Voir et gérer',
    MemberPermission_View_Assigned: 'Voir les assignés',
    MemberPermissions_ExpensesTitle: 'Dépenses :',
    MemberPermissions_MembersAndAssigneesTitle: 'Membres & assignés :',
    MemberPermissions_TasksTitle: 'Activités :',
    MemberPermissions_ThisProjectTitle: 'Projet :',
    MemberPermissions_TimeEntriesTitle: 'Entrées de temps :',
    Members: '1#{0} membre#{0} membres',
    no_assignee: 'Aucun assigné',
    On: 'le ',
    OwnBudget: 'Budget pour cette activité :',
    PercentDone: '1#% effectué#% effectués',
    PermissionsSettingsTitle: 'Autorisations de {0}',
    project: 'Projet',
    Project_NotFound_Message: 'Le projet demandé est introuvable ou vous n\'avez pas la permission d\'y accéder. Veuillez consulter votre administrateur {brandName} pour les causes possibles. La clé de l\'objet est {0}.',
    Project_NotFound_Title: 'Projet demandé introuvable',
    Project_WasCompleted_Ok: 'Le projet a été terminé <b>{0} avant</b> sa date de fin planifiée',
    Project_WasCompleted_Trouble: 'Le projet a été terminé <b>{0} après</b> sa date de fin planifiée',
    Project_WasCompleted_Warning: 'Le projet a été terminé à sa date de fin planifiée',
    RatioOfMoneySpent: '1#{0} sur {1} dépensé#{0} sur {1} dépensés',
    RepeatActivity: 'Répéter',
    request: 'Demande',
    ResumeWorkHelpText: 'Vous avez terminé votre mission. ',
    ResumeWorkText: 'Reprendre le travail',
    RoleTitle: 'Rôle pour ce projet',
    Save: 'Enregistrer',
    Set_actualCompletionDate: 'Définir la date d’achèvement réelle',
    Set_budget: 'Définir le budget',
    Set_categoryId: 'Définir la catégorie',
    Set_customerId: 'Définir le client',
    Set_dates: 'Définir les dates ou la durée',
    Set_description: 'Ajouter une description',
    Set_endDate: 'Définir la date de fin prévue',
    Set_estimatedHours: 'Définir les heures estimées',
    Set_hoursLeft: 'Définir les heures restantes',
    Set_labor_budget: 'Définir le budget de main-d’œuvre',
    Set_portfolioId: 'Définir le portefeuille',
    Set_short_hoursLeft: 'Définir les heures restantes',
    SetAsRootLevel: 'Définir comme activité de niveau supérieur',
    SetCompleted: 'Marquer comme terminée',
    short_hoursLeft: '1# heure restante# heures restantes',
    show_checklist_label: 'Afficher la liste de contrôle',
    ShowCustomFields: 'Afficher les champs personnalisés',
    Spent: '1#h dépensée#h dépensées',
    Status: 'Statut : ',
    task: 'Tâche',
    Task_NotFound_Message: 'L’activité demandée est introuvable ou vous n’avez pas la permission d’y accéder. Consultez votre administrateur {brandName} pour les causes possibles. La clé de l’objet est {0}.',
    Task_NotFound_Title: 'Activité demandée introuvable',
    Task_WasCompleted_Ok: 'L’activité a été terminée <b>{0} avant</b> sa date de fin prévue',
    Task_WasCompleted_Trouble: 'L’activité a été terminée <b>{0} après</b> sa date de fin prévue',
    Task_WasCompleted_Warning: 'L’activité a été terminée à sa date de fin prévue',
    today: 'Aujourd’hui',
    UnFollow: 'Ne plus suivre',
    unfollow_all_activities_label: 'Ne plus suivre toutes les activités',
    WindowUnload_UnsavedChanges: 'Il y a des modifications non enregistrées. Êtes-vous sûr de vouloir quitter cette page ?',
};
